import type {
	SlashCommandDefinition,
	SlashCommandSuggestionImpl,
} from "@/components/editor/extensions/slash-commands/types"
import {
	bulletedListCommand,
	codeBlockCommand,
	heading1Command,
	heading2Command,
	heading3Command,
	inlineImageCommand,
	loomVideoCommand,
	numberedListCommand,
	quoteCommand,
} from "@/components/editor/extensions/slash-commands/commands"
import { suggestion as baseSuggestion } from "@/components/editor/extensions/slash-commands/suggestion"

const threadSlashCommandItems: SlashCommandDefinition[] = [
	heading1Command,
	heading2Command,
	heading3Command,
	numberedListCommand,
	bulletedListCommand,
	quoteCommand,
	codeBlockCommand,
	inlineImageCommand,
	loomVideoCommand,
]

export const threadSuggestion: SlashCommandSuggestionImpl = {
	items: ({ query }) => {
		const lowerQuery = query.toLocaleLowerCase()
		return threadSlashCommandItems
			.filter((item) => {
				const titleMatch = item.title.toLocaleLowerCase().includes(lowerQuery)
				const aliasMatch = item.aliases?.some((alias) =>
					alias.toLocaleLowerCase().includes(lowerQuery),
				)
				return titleMatch || aliasMatch
			})
			.slice(0, 15)
	},
	render: baseSuggestion.render,
}
